import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from "@angular/core";
import { AlertService } from "../_services/index";
import {
  NgbModal,
  NgbActiveModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";
import { WeCOpinionPollsService } from "../_services/we-c-opinion-polls.service";
import { EncryptionService } from "../_services/encryption.service";
import { HttpClient } from "@angular/common/http";
import { take } from "rxjs/operators";
import { appConfig } from "../app.config";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class OpinionPolls {
  id: number;
  Option1: any;
  Option2: any;
  Option3: any;
  Option4: any;
  ClosingDate: any;
  AnswerTypeID: any;
  Question: any;
  isSponsered: any;
}

@Component({
  selector: "app-we-community-opinion-polls",
  templateUrl: "./we-community-opinion-polls.component.html",
  styleUrls: [
    "./we-community-opinion-polls.component.sass",
    "./we-community-opinion-polls.component.css",
  ],
})
export class WeCommunityOpinionPollsComponent implements OnInit {
  public doughnutChartLabels: any[] = [];
  public doughnutChartData: any[] = [0, 0, 0, 0];
  doughnutChartColors: any[] = [];
  public doughnutChartType: any = "doughnut";
  minValue: any = 0; // Initial minimum
  maxValue: any = 100; // Initial maximum
  public doughnutChartOptions: any = {
    responsive: true,
    cutoutPercentage: 100,
    legend: {
      position: "right",
    },
  };

  private subscription: Subscription;
  chartData: any = [];

  @ViewChild(DataTableDirective, { static: false })
  isEditMode: boolean = false;
  sliderValue: any;
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger = new Subject();
  start: number = 0;
  pageLength: number = 10;
  commentListArr: any = [];
  likeListArr: any = [];
  opinionPollList: OpinionPolls[] = [];
  isSubmitted = false;
  today: any;
  sliderQuestion: any;
  totalOpinionPolls: any;
  reportPostArr: any = [];
  commentViewArr: any = [];
  reportUserArr: any = [];

  getOpinionPolls = {
    id: "",
    Option1: "",
    Option2: "",
    Option3: "",
    Option4: "",
    ClosingDate: "",
    AnswerTypeID: "",
    Question: "",
    isSponsered: "N",
  };
  isSliderDisabled: boolean = false;
  modalReference: NgbActiveModal;
  modalTitle: string;
  answerTypeArr: any = [];
  showPastDateError: boolean = false;
  showOption3 = false;
  showOption4 = false;
  optionCount: any = 2;
  showloding = true;
  lodingImage = false;
  polls_data: any;
  commentQues: any;
  mentionUsers: any[] = [];
  mentionUsersSelected: any[] = [];
  mentionUserArr: any = [];
  voteCountsArr: any = [];
  getbaseUrl: any = "";

  constructor(
    public router: Router,
    private dataService: WeCOpinionPollsService,
    private alertService: AlertService,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private changeDetectorRef: ChangeDetectorRef,
    private modalService: NgbModal
  ) {
    const currentDate = new Date();
    this.today = currentDate.toISOString().split("T")[0];

    this.getbaseUrl = appConfig.webUrl;
  }

  opinion_polls = {
    id: "",
    Option1: "",
    Option2: "",
    Option3: "",
    Option4: "",
    ClosingDate: "",
    AnswerTypeID: "",
    Question: "",
    isSponsered: "N",
  };

  ngOnInit() {
    window.scroll(0, 0);
    this.getAnswerType();
    this.getOpinionPollListing();
    this.loadHide();
  }

  getRowNumber(index: number): number {
    return this.start + index + 1;
  }

  getOpinionPollListing() {
    // console.log("call");
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      order: [[0, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/we-community-opinion-list",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters))
              ),
            },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            var resp = JSON.parse(output);
            this.opinionPollList = resp["data"];
            this.totalOpinionPolls = resp["recordsTotal"];
            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: this.opinionPollList,
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "Question" },
        { data: "LikeCount" },
        { data: "CommentCount" },
        { data: "ReportCount" },
        { data: "getMentions" },
        { data: "ReportUserCount" },
        { data: "AnswerCount" },
        { data: "ClosingDate" },
        { data: "CreatedDate" },
      ],
    };
  }


  

  addMore() {
    if (this.optionCount < 4) {
      this.optionCount++;
    }
  }

  validateDate(control: any) {
    if (control.value != "") {
      const selectedDate = new Date(control.value).toISOString().split("T")[0];
      if (selectedDate < this.today) {
        return { dateError: true };
      }
    }
    return null;
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  getAnswerType() {
    this.dataService
      .getAnswerType()
      .pipe()
      .subscribe((res) => {
        if (res["status"] == 200) {
          this.answerTypeArr = res["data"];
        }
      });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  open(content) {
    this.isSubmitted = false;
    this.mentionUsers = [];
    this.mentionUsersSelected = [];
    this.opinion_polls.id = "";
    (this.opinion_polls.Option1 = ""),
      (this.opinion_polls.Option2 = ""),
      (this.opinion_polls.Option3 = ""),
      (this.opinion_polls.Option4 = ""),
      (this.opinion_polls.ClosingDate = ""),
      (this.opinion_polls.Question = ""),
      (this.opinion_polls.AnswerTypeID = "");
    this.modalTitle = "Add Opinion Polls";

    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  getMinDate(): string {
    const today = new Date();
    const dd: string = String(today.getDate()).padStart(2, "0");
    const mm: string = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy: string = today.getFullYear().toString();
    return `${yyyy}-${mm}-${dd}`; // Format: YYYY-MM-DD
  }

  edit(item: any, content) {
    this.loadHide();
    this.modalTitle = "Edit Opinion Polls";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });

    this.mentionUsersSelected = item.getMentions.map((user: any) => user.id);
    this.mentionUsers = item.getMentions ? item.getMentions : [];

    this.getOpinionPolls = item;
    this.opinion_polls = {
      id: this.getOpinionPolls.id,
      Question: this.getOpinionPolls.Question,
      Option1: this.getOpinionPolls.Option1,
      Option2: this.getOpinionPolls.Option2,
      Option3: this.getOpinionPolls.Option3,
      Option4: this.getOpinionPolls.Option4,
      ClosingDate: this.formatDate(this.getOpinionPolls.ClosingDate),
      AnswerTypeID: this.getOpinionPolls.AnswerTypeID,
      isSponsered: this.getOpinionPolls.isSponsered,
    };

    this.optionCount = 2;

    if (this.opinion_polls.Option3) {
      this.optionCount = 3; 
    }

    if (this.opinion_polls.Option4) {
      this.optionCount = 4; 
    }
  }

  filterMentions(event: any) {
    const searchTerm = event.term || "";

    if (searchTerm.length < 2) {
      this.mentionUsers = [];
      return;
    }

    this.dataService.communityMentionList(searchTerm).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.mentionUsers = res.list;
        }
      },
      (error) => {
        console.error("Error fetching users:", error);
      }
    );
  }

  formatDate(dateTimeString: any) {
    return dateTimeString.split(" ")[0];
  }

  insertAction(val, f) {
    let formData: FormData = new FormData();

    formData.append("Option1", this.opinion_polls.Option1);
    formData.append("Option2", this.opinion_polls.Option2);
    formData.append("Option3", this.opinion_polls.Option3);
    formData.append("Option4", this.opinion_polls.Option4);
    formData.append("ClosingDate", this.opinion_polls.ClosingDate);
    formData.append("AnswerTypeID", this.opinion_polls.AnswerTypeID);
    formData.append("Question", this.opinion_polls.Question);
    formData.append("isSponsered", this.opinion_polls.isSponsered);
    formData.append("mention_users", this.mentionUsersSelected.join(",") || "");

    if (val.id == "") {
      this.dataService
        .createOpinionPolls(formData)
        .pipe()
        .subscribe(
          (data) => {
            this.loadHide();
            this.modalReference.close();
            this.alertService.success(
              "We community opinion polls saved successfully",
              true
            );
            const table = $("#wecommunity").DataTable();
            table.ajax.reload(null, false);
          },
          (error) => {
            this.loadHide();
            this.alertService.error(error);
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
          }
        );
    } else {
      formData.append("id", val.id);
      this.dataService
        .updateOpinionPoll(formData)
        .pipe()
        .subscribe(
          (data) => {
            this.modalReference.close();
            const table = $("#wecommunity").DataTable();
            table.ajax.reload(null, false);
            this.alertService.success(
              "Opinion Polls updated successfully",
              true
            );
            this.loadHide();
          },
          (error) => {
            this.loadHide();
            this.alertService.error(error);
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
          }
        );
    }
  }

  onViewLikes(item, viewlikes) {
    const table = $("#wecommunity").DataTable();
    table.ajax.reload(null, false);
    this.commentListArr = [];
    this.modalTitle = "Like List";

    this.likeListArr = item.LikeCountArray;
    setTimeout(() => {
      this.modalReference = this.modalService.open(viewlikes, {
        windowClass: "vote-count-modal",
        backdrop: "static",
        keyboard: false,
      });
    }, 0);
  }

  onViewComments(item, viewcomments) {
    const table = $("#wecommunity").DataTable();
    table.ajax.reload(null, false);
    this.likeListArr = [];
    this.modalTitle = "Comment List";
    this.commentListArr = item.CommentArray;
    setTimeout(() => {
      this.modalReference = this.modalService.open(viewcomments, {
        windowClass: "comment-count-modal",
        backdrop: "static",
        keyboard: false,
      });
    }, 0);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  onCloseModal() {
    this.modalReference.close();
  }

  onViewReportPost(item, reportpost) {
    const table = $("#wecommunity").DataTable();
    table.ajax.reload(null, false);
    this.modalTitle = "Report Post List";
    this.reportPostArr = item.ReportArray;
    setTimeout(() => {
      this.modalReference = this.modalService.open(reportpost, {
        windowClass: "vote-count-modal",
        backdrop: "static",
        keyboard: false,
      });
    }, 0);
  }

  onViewReportUser(item, reportuser) {
    const table = $("#wecommunity").DataTable();
    table.ajax.reload(null, false);
    this.modalTitle = "Report User List";
    this.reportUserArr = item.ReportUserArray;

    setTimeout(() => {
      this.modalReference = this.modalService.open(reportuser, {
        windowClass: "vote-count-modal",
        backdrop: "static",
        keyboard: false,
      });
    }, 0);
  }

  onViewMentionUsers(item, mentionuser) {
    const table = $("#wecommunity").DataTable();
    table.ajax.reload(null, false);
    this.modalTitle = "Mention Users List";
    this.mentionUserArr = item.getMentions;

    setTimeout(() => {
      this.modalReference = this.modalService.open(mentionuser, {
        windowClass: "vote-count-modal",
        backdrop: "static",
        keyboard: false,
      });
    }, 0);
  }

  onVotesCount(item, votecounts) {
    this.changeDetectorRef.detectChanges();
    const table = $("#wecommunity").DataTable();
    table.ajax.reload(null, false);
    this.modalTitle = "Vote Counts";
    this.voteCountsArr = item;

    setTimeout(() => {
      this.modalReference = this.modalService.open(votecounts, {
        windowClass: "vote-count-modal",
        backdrop: "static",
        keyboard: false,
      });
    }, 0);
  }

  onView(item, modalTemplate, answerType) {
    this.loadShow();
    const table = $("#wecommunity").DataTable();
    table.ajax.reload(null, false);
    const modalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
    };

    setTimeout(() => {
      this.modalReference = this.modalService.open(modalTemplate, {
        windowClass: "comment-count-modal",
        backdrop: "static",
        keyboard: false,
      });
    }, 0);

    this.subscription = this.dataService
      .weCommunityView(item.id)
      .pipe(take(1))
      .subscribe((res: any) => {
        if (res["status"] === 200) {
          this.loadHide();
          if (answerType == 1 || answerType == 2) {
            this.chartData = res.data;
            this.polls_data = res.data.opinionanswers;

            const rawData = [
              this.polls_data.Option1 || 0,
              this.polls_data.Option2 || 0,
              this.polls_data.Option3 || 0,
              this.polls_data.Option4 || 0,
            ];

            const rawLabels = [
              this.chartData.Option1,
              this.chartData.Option2,
              this.chartData.Option3,
              this.chartData.Option4,
            ];

            const rawColors = [
              { backgroundColor: ["#86c7f3", "#ffa1b5", "#4394E5", "#B6A6E9"] },
            ];

            const filteredEntries = rawLabels
              .map((label, index) => ({
                label,
                data: rawData[index],
                color: rawColors[0].backgroundColor[index],
              }))
              .filter((entry) => entry.label && entry.label.trim() !== "");

            this.doughnutChartLabels = filteredEntries.map(
              (entry) => entry.label
            );
            this.doughnutChartData = filteredEntries.map((entry) => entry.data);
            this.doughnutChartColors = [
              {
                backgroundColor: filteredEntries.map((entry) => entry.color),
              },
            ];
          } else if (answerType == 3) {
            this.sliderQuestion = res.data.Question;
            this.sliderValue = res.data.opinionanswers.AverageRating;
            this.isSliderDisabled = true;
          } else if (answerType == 4) {
            this.commentQues = item.Question;
            this.commentViewArr = res.data.opinionanswers.Comments;
          }
        }
      });
  }

  closeModal() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  save(val, f) {
    this.isSubmitted = true;

    if (this.isFieldsInvalid(this.opinion_polls.Question)) {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (f.form.valid) {
      this.loadShow();
      this.insertAction(val, f);
    } else {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  checkClosingDate(event: string) {
    const selectedDate = new Date(event);
    const currentDate = new Date(this.today);

    if (selectedDate < currentDate) {
      this.opinion_polls.ClosingDate = "";
      this.showPastDateError = true;
    } else {
      this.showPastDateError = false;
    }
  }

  deleteComment(item) {
    this.loadShow();
    this.dataService
      .deleteComments(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            item.isActive = item.isActive === "Y" ? "N" : "Y";
            const table = $("#wecommunity").DataTable();
            table.ajax.reload(null, false);
            this.loadHide();
          } else {
            this.alertService.error("Error");
            this.loadHide();
          }
        },
        (error) => {
          this.alertService.error(error);
          this.loadHide();
        }
      );
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .deleteOpinionPolls(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success(
              "Opinion Poll deleted successfully",
              true
            );
            item.isActive = item.isActive === "Y" ? "N" : "Y";
          } else {
            this.alertService.error("Opinion Poll error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    this.loadHide();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  removeOption(optionNumber: any) {
    if (this.optionCount > 2) {
      this.optionCount--;
      if (optionNumber === 3) {
        this.opinion_polls.Option3 = "";
      } else if (optionNumber === 4) {
        this.opinion_polls.Option4 = "";
      }
    }
  }
}
